<template>
  <div class="text-center" ref="calculator-cta-header">
    <h2
      id="calculator-title"
      class="text-2xl sm:text-3xl xl:text-4xl font-extrabold tracking-tight text-primary-black leading-tight"
    >
      Soovid teada palju
      <br />võiks maksta sinu koduleht?
    </h2>
    <div class="mt-4 md:mt-8 flex justify-center">
      <button
        style="visibility: hidden"
        id="calculator-button"
        @click="swapComponent('calculator-page-style')"
        class="shadow-green px-10 py-3 border border-transparent text-sm uppercase tracking-wider leading-normal font-bold rounded-md text-white bg-green-300 hover:bg-indigo-400 focus:outline-none border-none focus:shadow-outline-indigo active:bg-indigo-400"
      >Vaata järele siit!</button>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";

export default {
  name: "CalculatorCtaHeader",
  methods: {
    swapComponent(step) {
      this.$emit("swapComponent", step);
    },
    animationsInit() {
      const trigger = this.$refs["calculator-cta-header"];
      const scroller = this.$parent.$parent.$parent.$refs["scrollSections"];
      const scrollTriggerDefaults = {
        trigger: trigger,
        scroller: scroller,
        start: "top 95%",
        end: "bottom 25%",
      };

      const calculatorTitleTl = gsap.timeline({
        scrollTrigger: {
          ...scrollTriggerDefaults,
        },
        defaults: {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 1,
          ease: "slow",
          autoAlpha: 1,
        },
      });
      calculatorTitleTl.to("#calculator-title", {});
      calculatorTitleTl.to("#calculator-button", {}, 0.3);
    },
  },
  mounted() {
    this.$nextTick(() => {
      gsap.set("#calculator-title", {
        y: 100,
        opacity: 0,
        scale: 0.8,
        autoAlpha: 0,
      });
      gsap.set("#calculator-button", {
        y: 100,
        opacity: 0,
        scale: 0.8,
        autoAlpha: 0,
      });
      this.animationsInit();
    });
  },
};
</script>

<style scoped>
</style>
